// scheduler.js
class $f7fd09830470ef3d$export$abc67becf848ae29 {
    constructor(containerId, options = {}){
        this.container = document.getElementById(containerId);
        this.days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        this.scheduleState = {};
        this.onSave = options.onSave || null;
        console.log("TimeScheduler initialized with container:", this.container);
    }
    // Set data from the API
    setSchedule(data) {
        this.scheduleState = data.schedule || {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: []
        };
        this.render();
    }
    getSchedule() {
        return this.scheduleState;
    }
    render() {
        if (!this.container) return;
        this.container.innerHTML = this.days.map((day, index)=>{
            const ranges = this.scheduleState[index] || [];
            //console.log(`Rendering ${day} (${index}: ${this.scheduleState[index]}):`, ranges);
            return `
                <div class="day-config-row" data-day="${index}">
                    <div class="day-header">
                        <span class="day-name">${day}</span>
                        <button class="btn-cyan btn-small btn-add-range" data-day="${index}">+ ADD RANGE</button>
                    </div>
                    <div class="ranges-container">
                        ${ranges.map((r, rIdx)=>`
                            <div class="time-chip">
                                ${r}
                                <span class="remove-range" data-day="${index}" data-idx="${rIdx}">\xd7</span>
                            </div>
                        `).join('')}
                        ${ranges.length === 0 ? '<span class="status-locked">\uD83D\uDD12 LOCKED WHOLE DAY</span>' : ''}                   </div>
                </div>
            `;
        }).join('');
        this.attachEventListeners();
    }
    attachEventListeners() {
        this.container.querySelectorAll('.btn-add-range').forEach((btn)=>{
            btn.onclick = (e)=>{
                const dayIdx = btn.getAttribute('data-day');
                e.preventDefault();
                this.promptNewRange(dayIdx);
            };
        });
        this.container.querySelectorAll('.remove-range').forEach((span)=>{
            span.onclick = (e)=>{
                const dayIdx = span.getAttribute('data-day');
                const rangeIdx = span.getAttribute('data-idx');
                this.removeRange(dayIdx, rangeIdx);
            };
        });
    }
    promptNewRange(dayIdx) {
        const modal = document.getElementById('timePickerModal');
        const confirmBtn = document.getElementById('timePickerConfirm');
        const cancelBtn = document.getElementById('timePickerCancel');
        const startInput = document.getElementById('rangeStart');
        const endInput = document.getElementById('rangeEnd');
        // Show the modal
        modal.style.display = 'flex';
        console.log(`Button ${dayIdx} was clicked, style model is now:`, modal.style.display);
        // Cleanup function to remove listeners
        const closeModal = ()=>{
            modal.style.display = 'none';
            confirmBtn.onclick = null;
            cancelBtn.onclick = null;
        };
        confirmBtn.onclick = ()=>{
            const start = startInput.value.split(':').slice(0, 2).join(':');
            const end = endInput.value.split(':').slice(0, 2).join(':');
            console.log(`Confirming new range for day ${dayIdx}:`, {
                start: start,
                end: end
            });
            if (start && end) {
                if (!this.scheduleState[dayIdx]) this.scheduleState[dayIdx] = [];
                document.getElementById('globalStart').value = start;
                document.getElementById('globalEnd').value = end;
                this.scheduleState[dayIdx].push(`${start}-${end}`);
                this.render();
            }
            closeModal();
        };
        cancelBtn.onclick = ()=>{
            closeModal();
        };
    }
    removeRange(dayIdx, rangeIdx) {
        this.scheduleState[dayIdx].splice(rangeIdx, 1);
        this.render();
    }
}


// Initialize the scheduler instance
const $b010e7379fa4e171$var$scheduler = new (0, $f7fd09830470ef3d$export$abc67becf848ae29)('weeklyScheduler');
const $b010e7379fa4e171$var$API_URL = window.location.origin.includes('localhost') ? `http://localhost:${undefined}/api` : '/api';
// --- MULTI-CLIENT STATE ---
let $b010e7379fa4e171$var$selectedClientId = null;
// UI Elements
const $b010e7379fa4e171$var$clientSelector = document.getElementById('clientSelector'); // Ensure this exists in HTML
const $b010e7379fa4e171$var$authModal = document.getElementById('authModal');
const $b010e7379fa4e171$var$modalInput = document.getElementById('modalInput');
const $b010e7379fa4e171$var$modalConfirm = document.getElementById('modalConfirm');
const $b010e7379fa4e171$var$modalCancel = document.getElementById('modalCancel');
const $b010e7379fa4e171$var$modalHeader = document.getElementById('modalHeader');
const $b010e7379fa4e171$var$settingsModal = document.getElementById('settingsModal');
const $b010e7379fa4e171$var$openSettingsBtn = document.getElementById('openSettingsBtn');
const $b010e7379fa4e171$var$closeSettingsBtn = document.getElementById('closeSettingsBtn');
const $b010e7379fa4e171$var$saveScheduledButton = document.getElementById('saveScheduleBtn');
const $b010e7379fa4e171$var$openAccessTimeBtn = document.getElementById('openAccessTimeBtn');
const $b010e7379fa4e171$var$timeAccessesModal = document.getElementById('timeAccessesModal');
const $b010e7379fa4e171$var$updateFirefoxAccessTime = document.getElementById('updateFirefoxAccessTime');
const $b010e7379fa4e171$var$timeAccessesModalCancel = document.getElementById('timeAccessesModalCancel');
// --- HELPER: HEADERS ---
function $b010e7379fa4e171$var$getHeaders(authKey = null, client = null) {
    const headers = {
        'Content-Type': 'application/json'
    };
    if (authKey) headers['Authorization'] = authKey;
    if (client) headers['x-client-id'] = client;
    return headers;
}
// --- CLIENT CONTEXT MANAGEMENT ---
async function $b010e7379fa4e171$var$setClient(id) {
    $b010e7379fa4e171$var$selectedClientId = id;
    localStorage.setItem('last_selected_client', id);
    // Refresh client-specific data
    await Promise.all([
        $b010e7379fa4e171$var$loadGlobalSettings(),
        $b010e7379fa4e171$var$loadHistory(),
        $b010e7379fa4e171$var$loadSchedule()
    ]);
}
function $b010e7379fa4e171$var$getClient() {
    if (!$b010e7379fa4e171$var$selectedClientId) $b010e7379fa4e171$var$showAlert('error', 'No client selected', "This actions requires a client to be selected.");
    return $b010e7379fa4e171$var$selectedClientId;
}
async function $b010e7379fa4e171$var$initClientList(adminPassword) {
    try {
        console.log(`Address server: ${$b010e7379fa4e171$var$API_URL}/clients`);
        //console.log(`'Authorization': ${adminPassword}`)
        const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/clients`, {
            headers: {
                'Authorization': adminPassword
            }
        });
        const clients = await res.json();
        console.log(`Client list:`, clients);
        if ($b010e7379fa4e171$var$clientSelector) {
            $b010e7379fa4e171$var$clientSelector.innerHTML = clients.map((c)=>`<option value="${c.id}">${c.id}</option>`).join('');
            const last = localStorage.getItem('last_selected_client');
            const initialId = last && clients.find((c)=>c.id === last) ? last : clients[0]?.id;
            $b010e7379fa4e171$var$clientSelector.value = initialId;
            $b010e7379fa4e171$var$setClient(initialId);
            $b010e7379fa4e171$var$clientSelector.onchange = (e)=>$b010e7379fa4e171$var$setClient(e.target.value);
        }
    } catch (e) {
        console.error("Failed to load clients", e);
    }
    // Now that selectedClientId is guaranteed, load the rest
    $b010e7379fa4e171$var$loadTargets(false);
    $b010e7379fa4e171$var$loadHistory();
    $b010e7379fa4e171$var$loadGlobalSettings();
    $b010e7379fa4e171$var$loadSchedule();
}
// --- DATA CALCULATION & UI ---
function $b010e7379fa4e171$var$calculateDailyTotal(ranges) {
    if (!ranges || ranges.length === 0) return 0;
    let totalMinutes = 0;
    ranges.forEach((range)=>{
        const [start, end] = range.split('-');
        const [sH, sM] = start.split(':').map(Number);
        const [eH, eM] = end.split(':').map(Number);
        totalMinutes += eH * 60 + eM - (sH * 60 + sM);
    });
    return (totalMinutes / 60).toFixed(1);
}
function $b010e7379fa4e171$var$updateSyntheticView(data) {
    const dayNames = [
        'SUN',
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT'
    ];
    const grid = document.getElementById('statusGrid');
    const summary = document.getElementById('todayWindows');
    const todayIndex = new Date().getDay();
    let gridHTML = '';
    for(let i = 0; i < 7; i++){
        const hours = $b010e7379fa4e171$var$calculateDailyTotal(data[i]);
        const isToday = i === todayIndex;
        gridHTML += `
            <div class="day-stat" style="${isToday ? 'border-bottom: 2px solid #00f3ff;' : ''}">
                <span class="day-label">${dayNames[i]}</span>
                <span class="hour-value ${hours <= 0 ? 'zero' : ''}">${hours}<span class="hour-unit">H</span></span>
            </div>`;
    }
    grid.innerHTML = gridHTML;
    summary.innerText = data[todayIndex]?.length > 0 ? data[todayIndex].join(' | ') : 'STANDBY MODE (NO ACCESS)';
}
// --- API FETCHERS ---
async function $b010e7379fa4e171$var$loadGlobalSettings() {
    const client = $b010e7379fa4e171$var$getClient();
    if (!client) return;
    try {
        const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/settings/time`, {
            headers: $b010e7379fa4e171$var$getHeaders(null, client)
        });
        if (!res.ok) throw new Error("Settings fetch failed");
        const data = await res.json();
        // Map DB fields to the HTML Input elements
        if (data.min_start_time) document.getElementById('globalStart').value = data.min_start_time;
        if (data.max_start_time) document.getElementById('globalEnd').value = data.max_start_time;
    } catch (e) {
        console.error("Error loading global settings:", e);
    }
}
function $b010e7379fa4e171$var$showModal(message) {
    $b010e7379fa4e171$var$authModal.style.display = 'flex';
    $b010e7379fa4e171$var$modalInput.value = '';
    $b010e7379fa4e171$var$modalHeader.textContent = message;
    $b010e7379fa4e171$var$modalInput.classList.remove('shake');
    // Timeout ensures the element is visible before focusing
    setTimeout(()=>{
        $b010e7379fa4e171$var$modalInput.focus();
    }, 10);
}
function $b010e7379fa4e171$var$closeModal() {
    $b010e7379fa4e171$var$authModal.style.display = 'none';
    $b010e7379fa4e171$var$modalInput.classList.remove('shake');
}
// --- Modal Logic ---
function $b010e7379fa4e171$var$requestPassword(message = "ACCESS KEY REQUIRED") {
    return new Promise((resolve)=>{
        $b010e7379fa4e171$var$showModal("\u262F " + message.toUpperCase());
        $b010e7379fa4e171$var$modalConfirm.onclick = ()=>{
            const val = $b010e7379fa4e171$var$modalInput.value;
            $b010e7379fa4e171$var$closeModal();
            resolve(val);
        };
        $b010e7379fa4e171$var$modalCancel.onclick = ()=>{
            $b010e7379fa4e171$var$closeModal();
            resolve(null);
        };
    });
}
function $b010e7379fa4e171$var$showAlert(type = 'info', title = 'SYSTEM MESSAGE', message = '') {
    return new Promise((resolve)=>{
        const infoModal = document.getElementById('infoModal');
        const infoTitle = document.getElementById('infoTitle');
        const infoMessage = document.getElementById('infoMessage');
        const infoClose = document.getElementById('infoClose');
        // 1. Set the text
        infoTitle.textContent = `\u{262F} ${title.toUpperCase()}`;
        infoMessage.textContent = message;
        // 2. Set the style based on type
        infoTitle.className = 'modal-header'; // Reset
        infoTitle.classList.add(`header-${type}`);
        // 3. Show and handle close
        infoModal.style.display = 'flex';
        infoClose.onclick = ()=>{
            infoModal.style.display = 'none';
            resolve();
        };
    });
}
// --- Protected API ---
async function $b010e7379fa4e171$var$secureApi(path, method, body, client = null) {
    const key = await $b010e7379fa4e171$var$requestPassword();
    if (!key) return;
    const res = await fetch(`${$b010e7379fa4e171$var$API_URL}${path}`, {
        method: method,
        headers: $b010e7379fa4e171$var$getHeaders(key, client),
        body: JSON.stringify(body)
    });
    if (res.status === 401) await $b010e7379fa4e171$var$showAlert('error', 'Security issue', "Invalid password used.");
    else if (res.ok) {
        $b010e7379fa4e171$var$closeModal();
        await $b010e7379fa4e171$var$showAlert('info', 'Action Successful', "Action completed successfully.");
        $b010e7379fa4e171$var$loadHistory();
    }
}
// --- Actions ---
document.getElementById('allowBtn').onclick = async ()=>{
    const client = $b010e7379fa4e171$var$getClient();
    if (!client) return;
    const checked = Array.from(document.querySelectorAll('.site-selector input:checked')).map((i)=>i.value);
    const manual = document.getElementById('customSite').value.trim();
    let sites = [
        ...new Set([
            ...checked,
            ...manual ? [
                manual
            ] : []
        ])
    ];
    if (sites.length === 0) {
        await $b010e7379fa4e171$var$showAlert('error', 'No webSite selected', "Please select at least one website.");
        return;
    }
    $b010e7379fa4e171$var$secureApi('/allow', 'POST', {
        sites: sites,
        duration: document.getElementById('duration').value
    }, client);
};
document.getElementById('stopBtn').onclick = ()=>{
    const client = $b010e7379fa4e171$var$getClient();
    if (!client) return;
    $b010e7379fa4e171$var$secureApi('/stop', 'POST', {}, client);
};
document.getElementById('changePassBtn').onclick = async ()=>{
    const oldPassword = await $b010e7379fa4e171$var$requestPassword("Enter your current passowrd");
    if (!oldPassword) return;
    // For change password, we need a special flow for the new password
    const newPassword = await $b010e7379fa4e171$var$requestPassword("Enter your new passowrd");
    if (!newPassword) return;
    const newPasswordRetypeed = await $b010e7379fa4e171$var$requestPassword("Confirm your new password");
    if (!newPasswordRetypeed) return;
    if (newPassword !== newPasswordRetypeed) return await $b010e7379fa4e171$var$showAlert('error', 'Password not changed', "The 2 passwords do not match.");
    const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/change-password`, {
        method: 'POST',
        headers: $b010e7379fa4e171$var$getHeaders(oldPassword, null),
        body: JSON.stringify({
            oldPassword: oldPassword,
            newPassword: newPassword
        })
    });
    if (res.ok) await $b010e7379fa4e171$var$showAlert('info', 'Password Changed Successfully', "Password has been successfully changed.");
    else await $b010e7379fa4e171$var$showAlert('error', 'Password not changed', "Password Verification Failed.");
};
$b010e7379fa4e171$var$openAccessTimeBtn.onclick = ()=>{
    // Pre-fill the modal with current values from the main screen
    document.getElementById('pickerStart').value = document.getElementById('globalStart').value;
    document.getElementById('pickerEnd').value = document.getElementById('globalEnd').value;
    $b010e7379fa4e171$var$timeAccessesModal.style.display = 'flex';
};
$b010e7379fa4e171$var$timeAccessesModalCancel.onclick = ()=>{
    $b010e7379fa4e171$var$timeAccessesModal.style.display = 'none';
};
$b010e7379fa4e171$var$updateFirefoxAccessTime.onclick = async ()=>{
    const start = document.getElementById('pickerStart').value;
    const end = document.getElementById('pickerEnd').value;
    const client = $b010e7379fa4e171$var$getClient();
    if (!client) return;
    const key = await $b010e7379fa4e171$var$requestPassword("AUTHORIZE TIME UPDATE");
    if (!key) return;
    try {
        const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/settings/time`, {
            method: 'POST',
            headers: $b010e7379fa4e171$var$getHeaders(key, client),
            body: JSON.stringify({
                min_start_time: start,
                max_start_time: end
            })
        });
        if (res.ok) {
            // Update the read-only display on the main page
            document.getElementById('globalStart').value = start;
            document.getElementById('globalEnd').value = end;
            $b010e7379fa4e171$var$timeAccessesModal.style.display = 'none';
            await $b010e7379fa4e171$var$showAlert('info', 'Settings Updated', "Global time settings updated. System refresh may take a few minutes.");
        } else await $b010e7379fa4e171$var$showAlert('error', 'Update Failed', "Unauthorized access.");
    } catch (error) {
        console.error("Update Firefox Access Time Failed:", error);
    }
};
$b010e7379fa4e171$var$openSettingsBtn.onclick = async ()=>{
    $b010e7379fa4e171$var$settingsModal.style.display = 'flex';
    $b010e7379fa4e171$var$loadTargets(true);
};
$b010e7379fa4e171$var$closeSettingsBtn.onclick = ()=>{
    $b010e7379fa4e171$var$settingsModal.style.display = 'none';
    $b010e7379fa4e171$var$loadTargets(false);
};
async function $b010e7379fa4e171$var$loadSchedule() {
    const client = $b010e7379fa4e171$var$getClient();
    if (!client) return;
    try {
        const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/settings/poweronschedule`, {
            headers: $b010e7379fa4e171$var$getHeaders(null, client)
        });
        const data = await res.json();
        $b010e7379fa4e171$var$scheduler.setSchedule(data);
        $b010e7379fa4e171$var$updateSyntheticView(data.schedule);
    } catch (e) {
        console.error("Failed to load schedule", e);
    }
}
$b010e7379fa4e171$var$saveScheduledButton.onclick = async ()=>{
    const currentData = $b010e7379fa4e171$var$scheduler.getSchedule();
    const key = await $b010e7379fa4e171$var$requestPassword("AUTHORIZE POWER ON TIME UPDATE");
    const client = $b010e7379fa4e171$var$getClient();
    if (!client) return;
    if (!key) return;
    try {
        const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/settings/poweronschedule`, {
            method: 'POST',
            headers: $b010e7379fa4e171$var$getHeaders(key, client),
            body: JSON.stringify({
                schedule: currentData
            })
        });
        if (res.ok) {
            await $b010e7379fa4e171$var$showAlert('info', 'Schedule Deployed', "Protocol updated successfully.");
            $b010e7379fa4e171$var$updateSyntheticView(currentData);
        } else await $b010e7379fa4e171$var$showAlert('error', 'Schedule update Failed', "Unauthorized access.");
    } catch (e) {
        console.error("PowerOn Schedule failed: ", e);
    }
};
async function $b010e7379fa4e171$var$init() {
    // 1. Check if the system even has a password yet
    const authRes = await fetch(`${$b010e7379fa4e171$var$API_URL}/auth-status`);
    const { initialized: initialized } = await authRes.json();
    if (!initialized) {
        await $b010e7379fa4e171$var$showAlert('warning', 'First start', "Please setup a password.");
        const n1 = await $b010e7379fa4e171$var$requestPassword("Enter your passowrd");
        if (!n1) return;
        const n2 = await $b010e7379fa4e171$var$requestPassword("Confirm your password");
        if (!n2) return;
        if (n1 !== n2) return await $b010e7379fa4e171$var$showAlert('error', 'Password not set', "The 2 passwords do not match.");
        await fetch(`${$b010e7379fa4e171$var$API_URL}/setup-password`, {
            method: 'POST',
            body: JSON.stringify({
                password: n1
            }),
            headers: $b010e7379fa4e171$var$getHeaders(null, null)
        });
    }
    // 2. Load the client list and WAIT for it to set the selectedClientId
    // We need the admin password to even see the client list based on your server code
    const adminKey = await $b010e7379fa4e171$var$requestPassword("Unlock Admin Console");
    if (!adminKey) return;
    await $b010e7379fa4e171$var$initClientList(adminKey);
}
// --- Initialization ---
// async function init() {
//     loadTargets(false);
//     loadHistory();
//     loadGlobalSettings();
//     try {
//         const res = await fetch(`${API_URL}/auth-status`);
//         const { initialized } = await res.json();
//         if (!initialized) {
//             await showAlert('warning', 'First start', "Please setup a password (Do not reuse any of your passwords).");
//             const p = await requestPassword();
//             await fetch(`${API_URL}/setup-password`, {
//                 method: 'POST',
//                 headers: getHeaders(null, null),
//                 body: JSON.stringify({ password: p })
//             });
//         }
//         loadHistory();
//         modalInput.addEventListener('keydown', (event) => {
//             if (event.key === 'Enter') {
//                 // Prevent the default behavior (like form submission) 
//                 event.preventDefault(); 
//                 // Trigger the click event on the confirm button
//                 modalConfirm.click();
//             }
//         });
//         modalCancel.addEventListener('click', closeModal);
//         window.addEventListener('keydown', (e) => {
//             if (e.key === 'Escape' && authModal.style.display !== 'none') {
//                 closeModal();
//             }
//         });
//         console.log("Initialization complete, loading schedule...");
//         loadSchedule();
//     } catch (e) {
//         console.error("Init failed: ", e)
//     }
// }
function $b010e7379fa4e171$var$formatFullCreationString(selectedSites, isoTimestamp, durationMins) {
    const date = new Date(isoTimestamp);
    // Formats to "Jan 1, 11:23 AM"
    const datePart = date.toLocaleDateString([], {
        month: 'short',
        day: 'numeric'
    });
    const timePart = date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
    let result = '';
    if (selectedSites !== null && selectedSites !== undefined) result = `Sites: ${selectedSites?.join(', ')}  - \t`;
    result += `${datePart}, ${timePart}`;
    // Add duration only if it exists and is not null
    if (durationMins !== null && durationMins !== undefined) result += ` for ${durationMins}m`;
    return result;
}
async function $b010e7379fa4e171$var$loadHistory() {
    const client = $b010e7379fa4e171$var$getClient();
    if (!client) return;
    try {
        const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/history`, {
            headers: $b010e7379fa4e171$var$getHeaders(null, client)
        });
        const data = await res.json();
        document.getElementById('historyList').innerHTML = data.map((i)=>`
            <div class="log-item">
                <small>[${i.client_id}]</small> <strong>${i.action}</strong>: 
                ${$b010e7379fa4e171$var$formatFullCreationString(i.sites, i.timestamp, i.duration_minutes)}
            </div>
        `).join('');
    } catch (e) {
        console.error("Load history failed: ", e);
    }
}
async function $b010e7379fa4e171$var$loadTargets(isManagementMode = false) {
    const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/targets`, {
        headers: $b010e7379fa4e171$var$getHeaders()
    });
    const targets = await res.json();
    if (isManagementMode) document.getElementById('modalSiteList').innerHTML = targets.map((site)=>`
            <div class="modal-site-item">
                <span>${site.name}</span>
                <button class="btn-danger" style="padding: 5px 10px; font-size: 10px;" 
                    onclick="deleteTarget(${site.id}, '${site.name}')">REMOVE</button>
            </div>`).join('');
    else document.getElementById('siteSelector').innerHTML = targets.map((site)=>`
            <label class="site-btn">
                <input type="checkbox" value="${site.address}">
                <span>${site.name}</span>
            </label>`).join('');
}
window.deleteTarget = async (id, name)=>{
    const confirmDelete = await $b010e7379fa4e171$var$requestPassword(`DELETE ${name.toUpperCase()}?`);
    if (!confirmDelete) return;
    const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/targets/${id}`, {
        method: 'DELETE',
        headers: $b010e7379fa4e171$var$getHeaders(confirmDelete, null)
    });
    if (res.ok) {
        await $b010e7379fa4e171$var$showAlert('info', 'Target Neutralized', `${name} has been removed.`);
        $b010e7379fa4e171$var$loadTargets(true);
    } else await $b010e7379fa4e171$var$showAlert('error', 'Action Failed', "Unauthorized access.");
};
document.getElementById('addNewTargetBtn').onclick = async ()=>{
    const name = document.getElementById('newSiteName').value.trim();
    const address = document.getElementById('newSiteAddress').value.trim();
    if (!name || !address) return $b010e7379fa4e171$var$showAlert('error', 'Missing Data', "Please provide both a name and an address.");
    // Reuse your existing secureApi logic or call fetch directly with auth
    const key = await $b010e7379fa4e171$var$requestPassword("AUTHORIZE NEW TARGET");
    if (!key) return;
    const res = await fetch(`${$b010e7379fa4e171$var$API_URL}/targets`, {
        method: 'POST',
        headers: $b010e7379fa4e171$var$getHeaders(key, null),
        body: JSON.stringify({
            name: name,
            address: address
        })
    });
    if (res.ok) {
        document.getElementById('newSiteName').value = '';
        document.getElementById('newSiteAddress').value = '';
        await $b010e7379fa4e171$var$showAlert('info', 'Target Added', `${name} is now in your mission list.`);
        $b010e7379fa4e171$var$loadTargets(true); // loadTargets(false);
    } else await $b010e7379fa4e171$var$showAlert('error', 'Unauthorized', "Invalid password.");
};
// --- STARFIELD ANIMATION ---
$b010e7379fa4e171$var$init();
const $b010e7379fa4e171$var$canvas = document.getElementById('starCanvas');
const $b010e7379fa4e171$var$ctx = $b010e7379fa4e171$var$canvas.getContext('2d');
let $b010e7379fa4e171$var$stars = [];
const $b010e7379fa4e171$var$starCount = 300; // Lower count looks cleaner over a background image
function $b010e7379fa4e171$var$resize() {
    $b010e7379fa4e171$var$canvas.width = window.innerWidth;
    $b010e7379fa4e171$var$canvas.height = window.innerHeight;
}
window.addEventListener('resize', $b010e7379fa4e171$var$resize);
$b010e7379fa4e171$var$resize();
class $b010e7379fa4e171$var$Star {
    constructor(){
        this.init();
    }
    init() {
        this.x = Math.random() * $b010e7379fa4e171$var$canvas.width;
        this.y = Math.random() * $b010e7379fa4e171$var$canvas.height;
        this.size = Math.random() * 1.5 + 0.5;
        this.speedY = Math.random() * 0.4 * (this.y > $b010e7379fa4e171$var$canvas.height / 2 ? -1 : 1);
        this.speedX = Math.random() * 0.4 * (this.y > $b010e7379fa4e171$var$canvas.width / 2 ? -1 : 1);
        this.opacity = Math.random() + 0.1;
        this.fadeSpeed = this.opacity / Math.min($b010e7379fa4e171$var$canvas.width / this.speedX, $b010e7379fa4e171$var$canvas.height / this.speedY);
        this.angle = Math.random() * Math.PI * 2;
        this.curve = (Math.random() - 0.5) * 0.02;
        // Match your theme colors: Cyan or Magenta
        this.color = Math.random() > 0.5 ? "255, 255, 255" : "255, 0, 128";
    }
    update() {
        this.angle += this.curve;
        this.x += Math.cos(this.angle) * this.speedX;
        this.y += Math.sin(this.angle) * this.speedY;
        this.y += this.speedY;
        this.x += this.speedX;
        this.opacity -= this.fadeSpeed;
        if (this.opacity <= 0 || this.x < 0 || this.x > $b010e7379fa4e171$var$canvas.width || this.y < 0 || this.y > $b010e7379fa4e171$var$canvas.height) this.init();
    }
    draw() {
        $b010e7379fa4e171$var$ctx.beginPath();
        let gradient = $b010e7379fa4e171$var$ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.size * 2);
        gradient.addColorStop(0, `rgba(${this.color}, ${this.opacity})`);
        gradient.addColorStop(1, `rgba(${this.color}, 0)`);
        $b010e7379fa4e171$var$ctx.fillStyle = gradient;
        $b010e7379fa4e171$var$ctx.arc(this.x, this.y, this.size * 2, 0, Math.PI * 2);
        $b010e7379fa4e171$var$ctx.fill();
    }
}
for(let i = 0; i < $b010e7379fa4e171$var$starCount; i++)$b010e7379fa4e171$var$stars.push(new $b010e7379fa4e171$var$Star());
function $b010e7379fa4e171$var$animate() {
    // Clear the canvas every frame to keep it transparent
    $b010e7379fa4e171$var$ctx.clearRect(0, 0, $b010e7379fa4e171$var$canvas.width, $b010e7379fa4e171$var$canvas.height);
    $b010e7379fa4e171$var$stars.forEach((star)=>{
        star.update();
        star.draw();
    });
    requestAnimationFrame($b010e7379fa4e171$var$animate);
}
$b010e7379fa4e171$var$animate();


//# sourceMappingURL=public.6d195e57.js.map
